/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Anil
 */

import { toast } from "react-toastify";

/******** Reducers ********/

const initialState = {
    Assistant: {
        data: null,
        loading: false,
        error: null,
        isSuccess: false
    },
    assistant_connectToFunction: {
        data: null,
        loading: false,
        error: null,
        isSuccess: false
    },
    phone_number: {
        data: null,
        loading: false,
        error: null,
        isSuccess: false
    },
    findTwilioPhone: {
        data: null,
        loading: false,
        error: null,
    },
    elevenLapToVapi: {
        data: null,
        loading: false,
        error: null,
    },
    call_list: {
        data: [],
        loading: false,
        error: null,
    },
    singlecall: {
        data: null,
        loading: false,
        error: null,
    },

    updatePhoneNumber: {
        data: null,
        loading: false,
        error: null
    },
    deletePhoneNumber: {
        loading: false,
        error: null
    },
    assistantPhoneNumber: {
        loading: false,
        error: null,
        data: null
    }

};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // api , state to fetch voice by id
        case 'CREATE_ASSISTANT_PENDING':
            return {
                ...state,
                Assistant: { loading: true, data: null, error: null, isSuccess: false }
            };

        case 'CREATE_ASSISTANT_FULFILLED':
            return {
                ...state,
                Assistant: {
                    loading: false,
                    data: action.payload,
                    error: null,
                    isSuccess: true
                }
            };

        case 'CREATE_ASSISTANT_FAILED':
            return {
                ...state,
                Assistant: { loading: false, data: null, error: action.payload, isSuccess: false }
            };
        case 'RESET_ASSISTANT_STATE':
            return {
                ...state,
                Assistant: { ...initialState.Assistant, isSuccess: false }
            };

        // connect function to assistant
        case 'Connect_ASSISTANT_PENDING':
            return {
                ...state,
                assistant_connectToFunction: { loading: true, data: null, error: null, isSuccess: false }
            };

        case 'Connect_ASSISTANT_FULFILLED':
            return {
                ...state,
                assistant_connectToFunction: { loading: false, data: action.payload, error: null, isSuccess: true }
            };

        case 'Connect_ASSISTANT_FAILED':
            return {
                ...state,
                assistant_connectToFunction: { loading: false, data: null, error: action.payload, isSuccess: false }
            };

        // ✅ Handle RESET action correctly
        case 'RESET_CONNECT_ASSISTANT_STATE':
            return {
                ...state,
                assistant_connectToFunction: { loading: false, data: null, error: null, isSuccess: false }
            };



        // import phone number
        case 'IMPORT_PHONE_NUMBER_PENDING':
            return {
                ...state,
                phone_number: { loading: true, data: null, error: null, isSuccess: false }
            };

        case 'IMPORT_PHONE_NUMBER_FULFILLED':
            return {
                ...state,
                phone_number: { loading: false, data: action.payload, error: null, isSuccess: true }
            };

        case 'IMPORT_PHONE_NUMBER_FAILED':
            return {
                ...state,
                phone_number: { loading: false, data: null, error: action.payload, isSuccess: false }
            };

        // find twilio phone number by phoneNumbe 
        case 'FindPhoneNumber_pending':
            return {
                ...state,
                findTwilioPhone: { loading: true, data: null, error: null, }
            };
        case 'FindPhoneNumber_fulfilled':
            let result = action.payload;
            let dataResult = result
            return {
                ...state,
                findTwilioPhone: { loading: false, data: dataResult, error: null, }
            };
        case 'FindPhoneNumber_failed':
            return {
                ...state,
                findTwilioPhone: { loading: false, data: null, error: action.payload, }
            };
        case 'RESET_reset_findTwilioPhone':
            return {
                ...state,
                findTwilioPhone: { loading: false, data: null, error: null, }
            };


        // connect elevan lab to vali
        // connect elevan lab to vali
        // connect elevan lab to vali
        case 'ConnectElevenLabToVapi_pending':
            return {
                ...state,
                elevenLapToVapi: { loading: true, data: null, error: null }
            };
        case 'ConnectElevenLabToVapi_fulfilled':

            return {
                ...state,
                elevenLapToVapi: { loading: false, data: action.payload, error: null }
            };
        case 'ConnectElevenLabToVapi_rejected':
            return {
                ...state,
                elevenLapToVapi: { loading: false, data: null, error: action.payload }
            };

        // find assistant in backend
        case 'isAssistant_pending':
            return {
                ...state,
                Assistant: { ...initialState.Assistant, loading: true }
            };
        case 'isAssistant_complete':

            return {
                ...state,
                Assistant: { ...initialState.Assistant, data: action.payload, loading: false }
            };
        case 'isAssistant_failed':
            return {
                ...state,
                Assistant: { ...initialState.Assistant, loading: false }
            };


        // get call list
        case 'get_call_list_pending':
            return {
                ...state,
                call_list: { data: [], error: null, loading: true }
            };
        case 'get_call_list_complete':

            return {
                ...state,
                call_list: { data: action.payload, error: null, loading: false }
            };
        case 'get_call_list_failed':
            return {
                ...state,
                call_list: { data: [], error: action.payload, loading: false }
            };


        // get single_call
        case 'sigle_call_pending':
            return {
                ...state,
                call_list: { data: [], error: null, loading: true }
            };
        case 'sigle_call_completed':
            return {
                ...state,
                call_list: { data: action.payload, error: null, loading: false }
            };
        case 'sigle_call_failed':
            return {
                ...state,
                call_list: { data: [], error: action.payload, loading: false }
            };


        // get single_call
        case 'update_assistant_pending':
            return {
                ...state,
                Assistant: {
                    data: null,
                    loading: true,
                    error: null,
                    isSuccess: false
                }
            };
        case 'update_assistant_complete':
            toast.success("Assistant updated successfully")
            // also update assistant in databae
            return {
                ...state,
                Assistant: {
                    data: action.payload,
                    loading: false,
                    error: null,
                    isSuccess: false
                }
            };
        case 'update_assistant_failed':
            toast.error("Something went wrong try later.")
            return {
                ...state,
                Assistant: {
                    ...initialState.Assistant,
                    error: action.payload,
                    isSuccess: false
                }
            };


        // get single_call
        case 'delete_Assistant_Pending':
            return {
                ...state,
                Assistant: {
                    ...initialState.Assistant,
                    loading: true,
                }
            };
        case 'delete_Assistant_fulfilled':
            // also update assistant in databae
            return {
                ...state,
                Assistant: {
                    data: null,
                    loading: false,
                    error: null,
                    isSuccess: false
                }
            };
        case 'delete_Assistant_fuiled':
            return {
                ...state,
                Assistant: {
                    ...initialState.Assistant,
                    isSuccess: false
                }
            };



        // find and update phone number
        case 'updatePhouneNumberPending':
            return {
                ...state,
                updatePhoneNumber: {
                    data: null,
                    loading: true,
                    error: null
                }
            };
        case 'updatePhouneNumberfuilfilled':
            // also update assistant in databae
            toast.success("Phone Number Update successfully")
            let currentAssistatn = state.Assistant.data.phoneNumber = action.payload
            return {
                ...state,
                updatePhoneNumber: {
                    data: action.payload,
                    loading: false,
                    error: null
                },
                Assistant: {
                    ...state.Assistant,
                    data: {
                        ...state.Assistant.data,
                        phoneNumber: action.payload
                    },
                    loading: false,
                    error: null,
                    isSuccess: false
                }
            };
        case 'updatePhouneNumberFailed':
            toast.error("Something went wrong try later")
            return {
                ...state,
                updatePhoneNumber: {
                    data: null,
                    loading: false,
                    error: action.payload
                }
            };


        // find and update phone number
        case 'deletePhoneNumber_pending':
            return {
                ...state,
                deletePhoneNumber: {
                    loading: true,
                    error: null
                }
            };
        case 'deletePhoneNumber_success':
            // also update assistant in databae
            toast.success("Phone number deleted successfully")
            return {
                ...state,
                deletePhoneNumber: {
                    loading: false,
                    error: null
                },
                Assistant: {
                    data: action.payload,
                    loading: false,
                    error: null,
                    isSuccess: false
                }
            };
        case 'deletePhoneNumber_failed':
            toast.error("Something went wrong try later.")
            return {
                ...state,
                deletePhoneNumber: {
                    loading: false,
                    error: action.payload
                }
            };



        // get assistant Phone number
        case 'getAssistantPhoneNumberPending':
            return {
                ...state,
                assistantPhoneNumber: { data: null, error: null, loading: true }
            };
        case 'getAssistantPhoneNumberfulfilled':
            console.log("dispatcvhe successful ")
            return {
                ...state,
                assistantPhoneNumber: { data: action.payload, error: null, loading: false }
            };
        case 'getAssistantPhoneNumberfailed':
            return {
                ...state,
                assistantPhoneNumber: { data: null, error: action.payload, loading: false }
            };

        default:
            return state;
    }
}



export const resetConnectAssistantState = () => ({
    type: "RESET_CONNECT_ASSISTANT_STATE",
});
export const resetAssistantState = () => ({
    type: "RESET_ASSISTANT_STATE",
});
export const reset_findTwilioPhone = () => ({
    type: "RESET_reset_findTwilioPhone",
});
